import { render, staticRenderFns } from "./EditNews.vue?vue&type=template&id=5f0c685e&"
import script from "./EditNews.vue?vue&type=script&lang=js&"
export * from "./EditNews.vue?vue&type=script&lang=js&"
import style0 from "./EditNews.vue?vue&type=style&index=0&id=5f0c685e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports